export default "__VITE_ASSET__0a93d50f__"